import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const DayOfWeek = types.compose(
  BaseEntity,
  types.model('DayOfWeek', {
    dowId: types.identifierNumber,
    englishName: types.string,
    frenchName: types.string,
    code: types.string,
  }),
);
